import React from "react";
import LoginContainer from "../pages/authentication/login/loginContainer";

import UserDetailsContainer from "../pages/usersManagement/userDetails/userDetailsContainer";
// import UsersManagementContainer from "../pages/usersManagement/usersManagementContainer";

import CurrentEventDetailContainer from "../components/eventManagmentTabs/currentEventDetail/currentEventDetailContainer";
// import CreateEditEventContainer from "../components/eventManagmentTabs/currentEventTab/createEditEvent/createEditEventContainer";
import Pages404 from "../pages/404/404";
import ArtistManagementContainer from "../pages/artistManagement/artistManagementContainer";
import ChangePasswordContainer from "../pages/authentication/changePassword/changePasswordContainer";
import ForgotPasswordContainer from "../pages/authentication/forgotPassword/forgotPasswordContainer";
import OtpVerificationContainer from "../pages/authentication/otpVerification/otpVerificationContainer";
import PasswordResetContainer from "../pages/authentication/resetPassword/resetPasswordContainer";
import SetPasswordContainer from "../pages/authentication/setPassword/setPasswordContainer";
import CategoryManagementContainer from "../pages/categoryManagement/categoryManagementContainer";
import ClubManagementContainer from "../pages/clubManagement/clubManagementContainer";
import ClubManagersAdminContainer from "../pages/clubManagersAdmin/clubManagersAdminContainer";
import ClubWebsiteEditorContainer from "../pages/clubWebsite/clubWebsiteEditorContainer";
import ClubCatalogContainer from "../pages/clubCatalog/clubCatalogContainer";
import ClubEmployeesContainer from "../pages/clubEmployees/clubEmployeesContainer";
import ClubCashiersContainer from "../pages/clubCashiers/clubCashiersContainer";
import ClubSalesAnalysisContainer from "../pages/clubSalesAnalysis/clubSalesAnalysisContainer";
import OfflineSaleContainer from "../pages/offlineSale/offlineSaleContainer";
import GuestlistContainer from "../pages/guestlist/guestlistContainer";
import GuestlistBulkImportContainer from "../pages/guestlist/GuestlistBulkImportContainer";
import GuestlistRouteGuard from "../components/GuestlistRouteGuard";
import { getClubMiniWebsitePathPrefix } from "../config/clubMiniWebsite";
import ClubMyTicketsContainer from "../pages/myTickets/ClubMyTicketsContainer";
import PublicTableSheetContainer from "../pages/tableSheet/PublicTableSheetContainer";
import ClubBookLatestContainer from "../pages/clubBookLatest/ClubBookLatestContainer";
import MyTicketsContainer from "../pages/myTickets/MyTicketsContainer";
import ClubManagerOnly from "../components/ClubManagerOnly";
import DenyClubManagerEventEdit from "../components/DenyClubManagerEventEdit";
import EventListContainer from "../pages/eventList/eventListContainer";
import EventPricingHubContainer from "../pages/eventPricingHub/EventPricingHubContainer";
import GenresManagementContainer from "../pages/genresManagement/genresManagementContainer";
import NotificationContainer from "../pages/notification/notificationContainer";
import OrganiserDetailsContainer from "../pages/usersManagement/organiserDetails/organiserDetailsContainer";
import CreateEditEventContainer1 from "../components/eventManagmentTabs/currentEventTab/createEditEvent/CreateEditEventContainer1";
// import CreateEditEventContainer2 from "../components/eventManagmentTabs/currentEventTab/createEditEvent/createEditEventContainer2";

const clubMiniWebsitePathPrefix = getClubMiniWebsitePathPrefix();

/**
 * An array of routes that are protected by authentication.
 * Each route object contains a path and an element/component to render when the path is matched.
 * @type {Array}
 * @property {string} path - The path of the route.
 * @property {ReactElement} element - The React element to render when the path is matched.
 * @property {boolean} [exact=false] - Specifies if the path should match exactly.
 * @property {ReactComponent} [component] - The React component to render when the path is matched.
 * @returns None
 */
const authProtectedRoutes = [
  { path: "/club-sales-analysis", element: <ClubSalesAnalysisContainer /> },
  // User management — hidden for admin
  // { path: "/users-management", element: <UsersManagementContainer /> },
  {
    path: "/events-list",
    element: <EventListContainer />,
  },
  {
    path: "/events-list/event-phases",
    element: <EventPricingHubContainer />,
  },
  // { path: "/events-list/add-event", element: <CreateEditEventContainer /> },
  // { path: "/events-list/edit-event", element: <CreateEditEventContainer /> },
  {
    path: "/events-list/add-event",
    element: <CreateEditEventContainer1 />,
  },
  {
    path: "/events-list/edit-event",
    element: <CreateEditEventContainer1 />,
  },
  {
    path: "/events-list/event-detail",
    element: <CurrentEventDetailContainer />,
  },
  { path: "/change-password", element: <ChangePasswordContainer /> },
  { path: "/notification", element: <NotificationContainer /> },
  { path: "/artist-management", element: <ArtistManagementContainer /> },
  // {
  //   path: "/users-management/users-details",
  //   element: <UserDetailsContainer />,
  // },
  // {
  //   path: "/users-management/organiser-details",
  //   element: <OrganiserDetailsContainer />,
  // },
  { path: "/genres-management", element: <GenresManagementContainer /> },
  { path: "/category-management", element: <CategoryManagementContainer /> },
  { path: "/clubs-management", element: <ClubManagementContainer /> },
  {
    path: "/clubs-management/club-managers",
    element: <ClubManagersAdminContainer />,
  },
  {
    path: "/clubs-management/website/:clubId",
    element: <ClubWebsiteEditorContainer />,
  },
  {
    path: "/clubs-management/catalog/:clubId",
    element: <ClubCatalogContainer />,
  },
  {
    path: "/club-guestlist",
    element: (
      <GuestlistRouteGuard>
        <GuestlistContainer />
      </GuestlistRouteGuard>
    ),
  },
];

const clubStaffRoutes = [
  { path: "/club-sales-analysis", element: <ClubSalesAnalysisContainer /> },
  {
    path: "/events-list",
    element: (
      <ClubManagerOnly>
        <EventListContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/events-list/event-phases",
    element: (
      <ClubManagerOnly>
        <EventPricingHubContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/events-list/add-event",
    element: (
      <ClubManagerOnly>
        <CreateEditEventContainer1 />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/events-list/edit-event",
    element: (
      <ClubManagerOnly>
        <DenyClubManagerEventEdit>
          <CreateEditEventContainer1 />
        </DenyClubManagerEventEdit>
      </ClubManagerOnly>
    ),
  },
  {
    path: "/events-list/event-detail",
    element: (
      <ClubManagerOnly>
        <CurrentEventDetailContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/club-website",
    element: (
      <ClubManagerOnly>
        <ClubWebsiteEditorContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/club-catalog",
    element: (
      <ClubManagerOnly>
        <ClubCatalogContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/club-employees",
    element: (
      <ClubManagerOnly>
        <ClubEmployeesContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/club-cashiers",
    element: (
      <ClubManagerOnly>
        <ClubCashiersContainer />
      </ClubManagerOnly>
    ),
  },
  {
    path: "/club-guestlist",
    element: (
      <GuestlistRouteGuard>
        <GuestlistContainer />
      </GuestlistRouteGuard>
    ),
  },
  {
    path: "/club-guestlist/bulk-import",
    element: (
      <ClubManagerOnly>
        <GuestlistBulkImportContainer />
      </ClubManagerOnly>
    ),
  },
  { path: "/club-offline-sale", element: <OfflineSaleContainer /> },
  { path: "/change-password", element: <ChangePasswordContainer /> },
];

const organiserRoutes = [
  {
    path: "/events-list",
    element: <EventListContainer />,
  },
  // { path: "/events-list/add-event", element: <CreateEditEventContainer /> },
  // { path: "/events-list/edit-event", element: <CreateEditEventContainer /> },
  {
    path: "/events-list/add-event",
    element: <CreateEditEventContainer1 />,
  },
  {
    path: "/events-list/edit-event",
    element: <CreateEditEventContainer1 />,
  },
  {
    path: "/events-list/event-detail",
    element: <CurrentEventDetailContainer />,
  },
  { path: "/change-password", element: <ChangePasswordContainer /> },
  { path: "/notification", element: <NotificationContainer /> },

  {
    path: "/users-management/users-details",
    element: <UserDetailsContainer />,
  },
  {
    path: "/users-management/organiser-details",
    element: <OrganiserDetailsContainer />,
  },
];

/**
 * An array of public routes for the application.
 * Each route object contains a path and an element component.
 * @type {Array<{ path: string, element: React.Component }>}
 */
const publicRoutes = [
  { path: "/set-password/:token", element: <SetPasswordContainer /> },
  { path: "/my-tickets/:orderId", element: <MyTicketsContainer /> },
  {
    path: `/${clubMiniWebsitePathPrefix}/:slug/my-tickets/:orderId`,
    element: <ClubMyTicketsContainer />,
  },
  {
    path: "/clubs/:slug/table-sheet",
    element: <PublicTableSheetContainer />,
  },
  {
    path: "/clubs/:slug/book",
    element: <ClubBookLatestContainer />,
  },
  { path: "/", element: <LoginContainer /> },

  { path: "/forgot-password", element: <ForgotPasswordContainer /> },
  { path: "/otp-verification", element: <OtpVerificationContainer /> },
  { path: "/reset-password", element: <PasswordResetContainer /> },

  { path: "/not-found", element: <Pages404 /> },
];

export { authProtectedRoutes, organiserRoutes, clubStaffRoutes, publicRoutes };
